import { Component, EventEmitter, HostListener, Injector, OnDestroy, OnInit, Output, effect } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { LanguageSelectionData } from 'src/app/shared/models';
import { TBSBaseComponent } from 'src/app/shared/models/tbsBaseComponent';
import { CTACustomFunctionService } from 'src/app/shared/services/ctacustom-function.service';

@Component({
    selector: 'app-masthead-articles',
    templateUrl: './masthead-articles.component.html',
    standalone: false
})
export class MastheadArticlesComponent extends TBSBaseComponent implements OnInit, OnDestroy {

  @Output() hasMegaMenuContent = new EventEmitter(false);
  megaMenuContents: any;
  isMobileView: boolean;
  isTabletView: boolean;
  isDesktopView: boolean;
  private screenWidth: number;
  statusofclick: boolean;
  @Output() onCloseClick = new EventEmitter();
  private resetOpenAccessDetailsPreviousValue: boolean;
  constructor(private readonly injector: Injector,
    public ctaCustomFn: CTACustomFunctionService,
    private readonly commonService: CommonService) {
    super(injector);
    this.addResourceStringKeys([

    ]);

    effect(() => {
      const isAuthenticated = this.commonService.resetOpenAccessDetails();
      if (this.resetOpenAccessDetailsPreviousValue !== isAuthenticated && this.helperService.isMemberSite) {
        this.getOurValuesMenu();
      }
      this.resetOpenAccessDetailsPreviousValue = isAuthenticated;
    })
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.onResize();
  }

  ngOnDestroy(): void {
    this.signalUnsubscribe();
  }
  adjustContentView(content) {
    if (this.isDesktopView) {
      if (content.length > 3) {
        return 'col-lg-3 col-sm-12 col-md-6';
      } else if (content.length == 3) {
        return 'col-lg-4 col-sm-12 col-md-4';
      } else if (content.length == 2) {
        return 'col-lg-6 col-sm-12 col-md-4';
      } else if (content.length == 1) {
        return 'col-lg-12 col-sm-12 col-md-6';
      }
    } else if (this.isTabletView) {
      if (content.length >= 2) {
        return 'col-lg-6 col-sm-12 col-md-6';
      } else if (content.length == 1) {
        return 'col-lg-12 col-sm-12 col-md-6';
      }
    } else {
      return 'col-lg-12 col-sm-12 col-md-6'
    }
  }
  
  @HostListener('window:resize', ['$event'])
  onResize(event: any = null) {
    if (event?.target?.innerWidth) {
      this.screenWidth = event?.target?.innerWidth;
    }
    if (this.screenWidth >= 992) {
      this.isDesktopView = true;
      this.isTabletView = false;
      this.isMobileView = false;
    }
    if (this.screenWidth < 992 && this.screenWidth >= 768) {
      this.isDesktopView = false;
      this.isTabletView = true;
      this.isMobileView = false;
    }
    if (this.screenWidth < 768) {
      this.isDesktopView = false;
      this.isTabletView = false;
      this.isMobileView = true;
    }
  }

  closeModal(cta): void {
    if (cta.additionalParameter != "" || cta.linkUrl != "") {
      this.statusofclick = true;
      this.onCloseClick.emit(this.statusofclick);
    }
  }

  private getOurValuesMenu() {
    let curLanguageCode: LanguageSelectionData = JSON.parse(localStorage.getItem('SelectedLanguage'));
    this.commonService.getCommonPageWithKey(curLanguageCode.cultureCode, "/Our-Values-Menu", "OurValuesMegaMenuItems", true)
      .subscribe(result => {
        this.megaMenuContents = result;
        if (this.megaMenuContents.length > 0) {
          let hasContent = false;
          this.megaMenuContents.forEach(megaMenuContent => {
            if (megaMenuContent.contentItems.length > 0 && !hasContent) {
              this.hasMegaMenuContent.emit(true);
              hasContent = true;
            }
            if (!hasContent) {
              this.hasMegaMenuContent.emit(false);
            }
          });
        } else {
          this.hasMegaMenuContent.emit(false);
        }
      });
  }
}
